import {
  IDeforestationRepository,
  DeforestationRecordEntity,
  DeforestationQueryRequestValueObject,
  DeforestationLayerEnum,
  ResponseValueObject,
} from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class DeforestationRepository implements IDeforestationRepository {
  async queryByLayer(
    layer: DeforestationLayerEnum,
    body: DeforestationQueryRequestValueObject,
  ): Promise<ResponseValueObject<DeforestationRecordEntity[]>> {
    try {
      const response = await axiosClient.post<{
        success: boolean;
        data: DeforestationRecordEntity[];
        message?: string;
      }>(
        `/deforestation/query/${layer}`,
        body.toJson(),
      );

      const payload = response.data;
      return new ResponseValueObject<DeforestationRecordEntity[]>(
        payload.success,
        payload.data ?? [],
        payload.message,
      );
    } catch (err: any) {
      return new ResponseValueObject<DeforestationRecordEntity[]>(
        false,
        [],
        err?.message ?? 'Error al consultar deforestación',
      );
    }
  }
}
